<template>
  <el-dialog title="电子签章信息" :visible.sync="visible" :before-close="handleClose" width="800px">

    <el-tabs v-model="activeName">
      <el-tab-pane label="签章属性" name="basic">
        <div class="ta-l tab-box">
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">签章人：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.esID }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">签章时间：</el-col>
            <el-col :span="20">{{ signedInfo.signedDate }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">原文属性：</el-col>
            <el-col :span="20">{{ signedInfo.propertyInfo }}</el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="印章基本信息" name="detailed">
        <div class=" ta-l tab-box">
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">印章标识：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.esID }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">印章名称：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.name }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">印章类型：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.type }}</el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">有效时间：</el-col>
            <el-col :span="20">
              有效起止日：{{ signedInfo.cert.notBefore }} 到 {{ signedInfo.cert.notAfter }}
            </el-col>
          </el-row>
          <el-row style="width: 100%;" class="mt10 mb10" v-if="signedInfo.eseal">
            <el-col :span="4">制章日期：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.createDate }}</el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="印章详细信息" name="statement" v-if="signedInfo.eseal">
        <div class="ta-l tab-box">
          <el-row style="width: 100%;" class="mt10 mb10">
            <el-col :span="4">厂商标识：</el-col>
            <el-col :span="20">{{ signedInfo.eseal.vid }}</el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>

  </el-dialog>
</template>

<script>

export default {
  name: "signatureInformation",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    signedInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      activeName: 'basic'
    };
  },
  methods: {
    // 关闭抽屉
    handleClose() {
      this.updateDialog(false)
    },
    /* 更新visible */
    updateDialog(value) {
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-tabs__content {
  display: flex;
  justify-content: flex-start;
}

.tab-box {
  height: 400px;
  width: 752px;
  font-size: 14px;
}
</style>
